module.exports = __webpack_public_path__ + "img/PPMP14.385a75ec.png";